import React, { useState } from 'react'
import { SettingsMenuButton } from 'src/editor/shared/components/settings-menu-buttons/settings-menu-button'
import { twMerge } from 'tailwind-merge'
import { SettingsNestedMenuScreen } from './settings-nested-menu-screen'

export interface SettingsNestedMenuProps {
  className?: string
  withHorizontalLine?: boolean
  menuButtonLabel: React.ReactNode
  menuButtonIcon?: () => React.ReactNode
  menuButtonClassName?: string
  menuTitle: string
  menuTitleClassName?: string
  children: React.ReactNode
  isOpen?: boolean
  onClose?: () => void
}

export const SettingsNestedMenu = ({
  className,
  withHorizontalLine,
  menuButtonLabel,
  menuTitle,
  menuTitleClassName,
  children,
  menuButtonClassName,
  menuButtonIcon,
  isOpen: isOpenFromProps,
  onClose,
}: SettingsNestedMenuProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const onBack = () => {
    setIsOpen(false)
    onClose?.()
  }
  return (
    <div
      className={twMerge(
        'mt-4',
        withHorizontalLine && 'border-0.5 border-border200 border-t pt-3',
        className,
      )}
    >
      <SettingsMenuButton
        className={menuButtonClassName}
        onClick={() => setIsOpen(true)}
        icon={menuButtonIcon}
      >
        {menuButtonLabel}
      </SettingsMenuButton>
      {(isOpenFromProps ?? isOpen) && (
        <SettingsNestedMenuScreen
          className={menuTitleClassName}
          title={menuTitle}
          onClose={onBack}
        >
          {children}
        </SettingsNestedMenuScreen>
      )}
    </div>
  )
}
